import { triggerHaptic } from '../../../shared/utils/haptics';

export type HapticType = 'shake' | 'jelly' | 'qtyChange' | 'press';

/** Health tagging on menu items — drives distinct haptic curves for quantity vs limit shake. */
export type MenuItemHealthHaptic = 'none' | 'allergy' | 'dislike';

/**
 * Trigger haptic feedback for tactile UI. Use from JS (e.g. in callbacks), not from worklets.
 * - shake: impactHeavy – limit exceeded, error state
 * - qtyChange: impactMedium – quantity increased or decreased
 * - press: impactLight – image or button press
 */
export function triggerTactileHaptic(type: HapticType): void {
  switch (type) {
    case 'shake':
      triggerHaptic('impactHeavy');
      break;
    case 'jelly':
    case 'press':
      triggerHaptic('impactLight');
      break;
    case 'qtyChange':
      triggerHaptic('impactMedium');
      break;
    default:
      triggerHaptic('impactLight');
  }
}

/**
 * Menu row quantity / limit-shake haptics — call only when the action commits (press end / stepper),
 * not on touch start. Allergy vs dislike use stronger warning-style feedback than neutral items.
 */
export function triggerMenuItemHaptic(action: 'quantity' | 'shake', health: MenuItemHealthHaptic): void {
  if (action === 'shake') {
    if (health === 'allergy') {
      triggerHaptic('notificationError');
      return;
    }
    if (health === 'dislike') {
      triggerHaptic('notificationWarning');
      return;
    }
    triggerHaptic('impactHeavy');
    return;
  }
  if (health === 'allergy') {
    triggerHaptic('rigid');
    return;
  }
  if (health === 'dislike') {
    triggerHaptic('soft');
    return;
  }
  triggerHaptic('impactMedium');
}
